export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-photos-beeae6e0d13d047f4977e605569bc388.png";